import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const ProductDetail = lazy(() => import('../pages/product/page'));
const CaseDetail = lazy(() => import('../pages/case/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const DistributionPage = lazy(() => import('../pages/distribution/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/product/:productId',
    element: <ProductDetail />,
  },
  {
    path: '/distribution',
    element: <DistributionPage />,
  },
  {
    path: '/case/:caseId',
    element: <CaseDetail />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
